<script>
    import { push } from "svelte-spa-router";
    import EventListItem from "./EventListItem.svelte";

    import { getEntities } from "../../../api-client";
    import LoadingSquare from "../../../common/LoadingSquare.svelte";
    import { locale } from "svelte-i18n";
    import RecentListItem from "../RecentListItem.svelte";
    import StoreItemItem from "../StoreItemItem.svelte";
    import { _ } from "svelte-i18n";
    import {
        getEvents,
        getFondationEvents,
    } from "../../../content/data/events";

    const _promise = () =>
        Promise.all([
            getEvents().then((events) => {
                return events
                    .filter((event) => event.isDashboardItem ?? false)
                    .map((event) => {
                        return {
                            ...event,
                            type: "event",
                        };
                    });
            }),
            getEntities("recent").then((recents) => {
                return recents
                    .filter((recent) => recent.isDashboardItem ?? false)
                    .map((recent) => {
                        return {
                            ...recent,
                            type: "recent",
                        };
                    });
            }),
            getEntities("store_item").then((storeItems) => {
                return storeItems
                    .filter((storeItem) => storeItem.isDashboardItem)
                    .map((storeItem) => {
                        return {
                            ...storeItem,
                            type: "store_item",
                        };
                    });
            }),
        ]).then((values) => {
            let [events, recents, store_items] = values;
            let sorted = [];

            for (
                let i = 0;
                i <
                (events.length > recents.length
                    ? events.length
                    : recents.length);
                i++
            ) {
                if (events[i]) {
                    sorted.push(events[i]);
                }

                if (recents[i]) {
                    sorted.push(recents[i]);
                }

                if (store_items[i]) {
                    sorted.push(store_items[i]);
                }
            }

            return sorted;
        });

    $: fondationPromise = getFondationEvents().then((data) =>
        data.filter((storeItem) => storeItem.isDashboardItem)
    );

    $: promise = _promise();

    let currentLocale = $locale;

    locale.subscribe((value) => {
        if (value === currentLocale) return;
        currentLocale = value;
        promise = _promise();
        fondationPromise = getFondationEvents().then((data) =>
            data.filter((storeItem) => storeItem.isDashboardItem)
        );
        console.log("Locale changed to " + currentLocale);
    });
</script>

{#await promise}
    <LoadingSquare />
{:then items}
    <div class="event-slideshow">
        {#each items as item, index}
            {#if item.type === "recent"}
                <div class="scroll-stop">
                    <RecentListItem
                        event={item}
                        flipped={index % 2 !== 0}
                        on:click={() => window.open(item.link, "_blank")}
                    />
                </div>
            {:else if item.type === "event"}
                <div class="scroll-stop">
                    <EventListItem
                        event={item}
                        flipped={index % 2 !== 0}
                        on:click={() => push("/event/" + item.id)}
                    />
                </div>
            {:else if item.type === "store_item"}
                <div class="scroll-stop">
                    <StoreItemItem
                        storeItem={item}
                        flipped={index % 2 !== 0}
                        on:click={() => push("/store_item/" + item.id)}
                    />
                </div>
            {/if}
            {#if index < items.length - 1}
                <div class="divider-v divider" />
            {/if}
        {/each}
        {#await fondationPromise then fondationEvents}
            {#each fondationEvents as event, index}
                {#if index < fondationEvents.length}
                    <div class="divider-v divider" />
                {/if}
                <div class="scroll-stop">
                    <EventListItem
                        {event}
                        flipped={index % 2 !== 0}
                        on:click={() => push("/event/" + event.id)}
                    />
                </div>
            {/each}
        {/await}
        <div style="height: 100%; min-width: 48px" />
    </div>
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}

<style>
    .event-slideshow {
        display: flex;
        flex-direction: row;
        margin: 0 16px 0 16px;
        height: 100%;
    }

    .divider {
        margin: 0px 16px;
        align-self: stretch;
        min-width: 1px;
    }

    .scroll-stop {
        scroll-snap-align: start;
    }

    @media only screen and (max-width: 799px) {
        .event-slideshow {
            height: 100%;
        }
    }
</style>
